import { Modal } from "antd";
import { useEffect, useMemo, useState } from "react";
import type { UploadFile } from "antd";
import { detectType, isHttpUrl } from "utils";

type InputFile = string | File | Blob | UploadFile;

interface Props {
  file: InputFile;
  name?: string;
}

export default function FilePreviewLink({ file, name }: Props) {
  const [open, setOpen] = useState(false);
  const [objectUrl, setObjectUrl] = useState<string | null>(null);

  // resolve url + name + mime
  const { url, filename, mime } = useMemo(() => {
    if (typeof file === "string") {
      return {
        url: file,
        filename: name || decodeURIComponent(file.split("/").pop() || "file"),
        mime: undefined,
      };
    }

    if ("originFileObj" in (file as UploadFile)) {
      const uploadFile = file as UploadFile;
      const f = uploadFile.originFileObj as File | Blob | undefined;
      return {
        url: f ? URL.createObjectURL(f) : uploadFile.url || "",
        filename: name || uploadFile.name || "file",
        mime: f?.type,
      };
    }

    if (file instanceof File || file instanceof Blob) {
      return {
        url: URL.createObjectURL(file),
        filename: name || "file",
        mime: file.type,
      };
    }

    return { url: "", filename: "file", mime: undefined };
  }, [file, name]);

  const type = useMemo(
    () => detectType(filename, mime),
    [filename, mime]
  );

  // manage blob cleanup
  useEffect(() => {
    if (url?.startsWith("blob:")) {
      setObjectUrl(url);
    }
  }, [url]);

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        setObjectUrl(null);
      }
    }
  }, []);

  
  useEffect(() => {
    if(open && type=== "pdf"){
      window.open(url, "_blank");
      setOpen(false);
    }
  }, [open, type]);


  const isCannotPreview = type === "office" && !(isHttpUrl(url)) || type === "other"

  return (
    <>
      <div
        className={` whitespace-nowrap text-ellipsis overflow-hidden ${isCannotPreview ? "" : "text-blue-500 cursor-pointer hover:underline"}`}
        onClick={() => !isCannotPreview && setOpen(true)}
      >
        {filename} 
      </div >

      <Modal
        title={filename}
        open={open && type!== "pdf"}
        footer={null}
        onCancel={handleClose}
        width={"100%"}

        centered
        destroyOnClose
        bodyStyle={{ width: "100%", height: "calc(100vh - 100px)" }}
      >
        <div className="flex justify-center items-center h-full">
          {type === "image" && (
            <img src={url} alt={filename} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
          )}

          {type === "video" && (
            <video src={url} controls style={{ width: "100%" }} />
          )}
          {type === "audio" && (
            <audio src={url} controls />
          )}

          {
            type === "office" && (
              <iframe style={{ width: "100%", height: "100%" }} title="Office プレビュー"
                src={`https://view.officeapps.live.com/op/view.aspx?src=${url}`} />)
          }

        </div>
      </Modal>
    </>
  );
}

